module.exports = {"classes":["all-legal-files-page","header-dark"],"title":"All Legal Files","metas":{"description":"Legal Information."},"opengraph":{"og:title":"All Legal Files","og:description":"Legal Information.","og:url":"https://auth0.com/legal/lall-legal-files"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/all-legal-files/metadata.json
// module id = 1638
// module chunks = 0